import React, { useEffect, useState } from "react";
import { useLanguage } from "../../context/LanguageContext";
import api from "../../lib/api.ts";
import { formatPrice } from "../../utils/functions";
import Pagination from "../common/Pagination";
import { useToast } from "../../context/ToastContext";

const ProfilePayment = () => {
  const { translate, language } = useLanguage();
  const isRTL = language === "ar";
  const [paymentData, setPaymentData] = useState([]);
  const authUser = localStorage.getItem("authUser");
  const user = authUser ? JSON.parse(authUser) : null;
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
  });
  const [isLoading, setIsLoading] = useState(true);

  //==========================friday fix release button for seller withdrawal invoice
    const { showSuccess, showError } = useToast();
  const [releaseLoading, setReleaseLoading] = useState(null);
  const [releaseMessage, setReleaseMessage] = useState(null);
  const [releaseError, setReleaseError] = useState(null);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
const [showReleaseConfirm, setShowReleaseConfirm] = useState(false);
  //=============================friday fix END
  useEffect(() => {
    const fetchPaymentData = async () => {
      setIsLoading(true);
      try {
        const response = await api.get(
          `/sellers/commissions?page=${pagination.currentPage}&limit=${pagination.itemsPerPage}`,
        );

        if (response.data && response.data.data) {
          setPaymentData(response.data.data);
          setPagination({
            currentPage: response.data.pagination?.currentPage || 1,
            totalPages: response.data.pagination?.totalPages || 1,
            totalItems: response.data.pagination?.totalItems || 0,
            itemsPerPage: response.data.pagination?.itemsPerPage || 10,
          });
        }
      } catch (error) {
        console.error("Error fetching payment data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPaymentData();
  }, [pagination.currentPage]);

  //=================fridy fix release button for seller withdrawal invoice detail (vehicle/commission row)=========================
  // const handleReleaseRequest = async (transaction) => {
  //   setReleaseError(null);
  //   setReleaseMessage(null);

  //   // prevent invalid calls
  //   if (
  //     transaction.paymentStatus !== "Paid" ||
  //     transaction.withdrawalRequestCount > 0 ||
  //     transaction.buyerInvoice?.paidToSeller ||
  //     releaseLoading === transaction.id
  //   ) {
  //     return;
  //   }

  //   setReleaseLoading(transaction.id);

  //   try {
  //     const response = await api.post(
  //       "/sellerwithdrawalinvoices/releaserequest",
  //       {
  //         buyerInvoiceDetailId: transaction.id,
  //       },
  //     );

  //     if (response.data && response.data.success) {
  //       setPaymentData((prev) =>
  //         prev.map((item) =>
  //           item.id === transaction.id
  //             ? {
  //                 ...item,
  //                 withdrawalRequestCount:
  //                   (item.withdrawalRequestCount || 0) + 1,
  //                 buyerInvoice: {
  //                   ...item.buyerInvoice,
  //                   paidToSeller: true,
  //                 },
  //               }
  //             : item,
  //         ),
  //       );

  //       setReleaseMessage(
  //         response.data.message || "Release request submitted successfully",
  //       );
  //     } else {
  //       setReleaseError(
  //         response.data?.message || "Failed to submit release request",
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error submitting release request:", error);
  //     setReleaseError(
  //       error.response?.data?.message ||
  //         error.message ||
  //         "Failed to submit release request",
  //     );
  //   } finally {
  //     setReleaseLoading(null);
  //   }
  // };
const handleConfirmRelease = async () => {
  if (!selectedTransaction) return;

  const transaction = selectedTransaction;

  if (releaseLoading === transaction.id) return;

  setReleaseError(null);
  setReleaseMessage(null);

  // validation
  if (
    transaction.paymentStatus !== "Paid" ||
    transaction.withdrawalRequestCount > 0 ||
    transaction.buyerInvoice?.paidToSeller
  ) {
    setShowReleaseConfirm(false);
    return;
  }

  try {
    setReleaseLoading(transaction.id);

    const response = await api.post(
      "/sellerwithdrawalinvoices/releaserequest",
      {
        buyerInvoiceDetailId: transaction.id,
      }
    );

    if (response.data && response.data.success) {
      // ✅ update UI
      setPaymentData((prev) =>
        prev.map((item) =>
          item.id === transaction.id
            ? {
                ...item,
                withdrawalRequestCount:
                  (item.withdrawalRequestCount || 0) + 1,
                buyerInvoice: {
                  ...item.buyerInvoice,
                  paidToSeller: true,
                },
              }
            : item
        )
      );

      // ✅ SUCCESS TOAST
      showSuccess(
        response.data.message ||
          translate("sellerPayment.messages.releaseSuccess") ||
          "Release request submitted successfully"
      );
    } else {
      const errorMsg =
        response.data?.message ||
        translate("sellerPayment.messages.releaseFailed") ||
        "Failed to submit release request";

      setReleaseError(errorMsg);
      showError(errorMsg);
    }
  } catch (error) {
    console.error("Error submitting release request:", error);

    const errorMsg =
      error.response?.data?.message ||
      error.message ||
      translate("sellerPayment.messages.releaseFailed") ||
      "Failed to submit release request";

    setReleaseError(errorMsg);
    showError(errorMsg);
  } finally {
    setReleaseLoading(null);
    setShowReleaseConfirm(false);
    setSelectedTransaction(null);
  }
};
  //=============================friday fix END=============================

  if (isLoading) {
    return (
      <div
        className="bg-[#FFF9F9] rounded-lg shadow-md"
        dir={isRTL ? "rtl" : "ltr"}
        lang={language}
      >
        {/* Header */}
        <div className="bg-[#fcfcfc1f] text-gray-700 font-medium rounded-t-[16px] px-1 py-1">
          <div className="p-[20px] text-lg rounded-t-[12px] font-semibold text-gray-700 bg-[#F153291F] border-b border-black pb-2">
            <h2 className="text-base sm:text-lg font-semibold">
              {translate("sellerPayment.heading")}
            </h2>
          </div>
        </div>
        <div className="px-3 py-6">
          <div className="animate-pulse">
            <div className="h-6 bg-gray-200 rounded w-1/3 mb-6"></div>
            <div className="space-y-3">
              {[1, 2, 3, 4, 5].map((i) => (
                <div key={i} className="h-16 bg-gray-200 rounded"></div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="bg-[#FFF9F9] rounded-lg shadow-md"
      dir={isRTL ? "rtl" : "ltr"}
      lang={language}
    >
      {/* Header */}
      <div className="bg-[#fcfcfc1f] text-gray-700 font-medium rounded-t-[16px] px-1 py-1">
        <div className="p-[20px] text-lg rounded-t-[12px] font-semibold text-gray-700 bg-[#F153291F] border-b border-black pb-2">
          <h2 className="text-base sm:text-lg font-semibold">
            {translate("sellerPayment.heading")}
          </h2>
        </div>
      </div>

      <div className="px-3 py-6">
        {/* //friday fix release button for seller withdrawal invoice  */}
        {releaseMessage && (
          <div className="mb-4 rounded-md bg-green-50 border border-green-200 p-3 text-sm text-green-800">
            {releaseMessage}
          </div>
        )}
        {releaseError && (
          <div className="mb-4 rounded-md bg-red-50 border border-red-200 p-3 text-sm text-red-800">
            {releaseError}
          </div>
        )}
        {/* //=======friday fix end=========== */}

        {/* Mobile Card View */}
        <div className="block lg:hidden space-y-4">
          {paymentData.map((transaction) => (
            <div
              key={transaction.id}
              className="bg-white rounded-lg shadow-sm border border-gray-200 p-4"
            >
              <div className="space-y-3">
                {/* Vehicle Info */}
                <div className="flex justify-between items-start">
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium text-gray-900 truncate">
                      {transaction.vehicle?.name || "-"}
                    </div>
                    <div className="text-xs text-gray-500">
                      {transaction.vehicle?.lotNumber || "-"}
                    </div>
                  </div>
                  {/* //=================friday fix release button for seller withdrawal invoice  */}
                  <button
                    disabled={
                      transaction.paymentStatus !== "Paid" ||
                      transaction.withdrawalRequestCount > 0 ||
                      transaction.buyerInvoice?.paidToSeller ||
                      releaseLoading === transaction.id
                    }
                    type="button"
                    // onClick={() => handleReleaseRequest(transaction)}
                    onClick={() => {
  setSelectedTransaction(transaction);
  setShowReleaseConfirm(true);
}}
                    className={`px-4 py-2 rounded-md text-sm whitespace-nowrap transition-colors
    ${
      transaction.paymentStatus === "Paid" &&
      !transaction.withdrawalRequestCount &&
      !transaction.buyerInvoice?.paidToSeller
        ? "bg-green-600 text-white hover:bg-green-700"
        : "bg-gray-300 text-gray-500 cursor-not-allowed"
    }`}
                  >
                    {transaction.withdrawalRequestCount > 0 ||
                    transaction.buyerInvoice?.paidToSeller
                      ? translate("sellerPayment.buttons.requested") ||
                        "Release Requested"
                      : translate("sellerPayment.buttons.release")}
                  </button>
                  {/* //friday fix release button end */}
                </div>

                {/* Financial Details */}
                <div className="grid grid-cols-2 gap-3 text-xs">
                  <div>
                    <div className="text-gray-500">
                      {translate("sellerPayment.labels.soldPrice")}
                    </div>
                    <div className="font-semibold text-green-600">
                      {formatPrice(
                        transaction.soldPrice,
                        "font-semibold text-green-600",
                        "12",
                        "#16a34a",
                      )}
                    </div>
                  </div>
                  <div>
                    <div className="text-gray-500">
                      {translate("sellerPayment.labels.commission")}
                    </div>
                    <div className="font-semibold text-blue-600">
                      {formatPrice(
                        transaction.commission,
                        "font-semibold text-blue-600",
                        "12",
                        "#2563eb",
                      )}
                    </div>
                  </div>
                  <div>
                    <div className="text-gray-500">
                      {translate("sellerPayment.labels.vat5")}
                    </div>
                    <div className="font-semibold text-orange-600">
                      {formatPrice(
                        transaction.vatAmount,
                        "font-semibold text-orange-600",
                        "12",
                        "#ea580c",
                      )}
                    </div>
                  </div>
                  {/* wednesday fix */}
                  <div>
                    <div className="text-gray-500">
                      {translate("sellerPayment.labels.listingFee")}
                    </div>
                    <div className="font-semibold text-grey-600">
                      {formatPrice(
                        transaction.listingFee || 0,
                        "font-semibold text-purple-600",
                        "12",
                        "#7c3aed",
                      )}
                    </div>
                  </div>

                  <div>
                    <div className="text-gray-500">
                      {translate("sellerPayment.labels.withdrawable")}
                    </div>
                    <div className="font-semibold text-gray-900">
                      {formatPrice(
                        (Number(transaction.totalCommission) || 0) +
                          (Number(transaction.listingFee) || 0),
                        "font-semibold text-red-600",
                        "12",
                        "#dc2626",
                      )}
                    </div>
                  </div>

                  <div>
                    <div className="text-gray-500">
                      {translate("sellerPayment.labels.withdrawable")}
                    </div>
                    <div className="font-semibold text-gray-900">
                      {formatPrice(
                        (Number(transaction.soldPrice) || 0) -
                          (Number(transaction.totalCommission) || 0) -
                          (Number(transaction.listingFee) || 0),
                        "font-semibold text-gray-900",
                        "12",
                        "#111827",
                      )}
                    </div>
                  </div>
                </div>
                {/* //=====================e============ */}

                {/* Sale Date */}
                <div className="text-xs text-gray-500">
                  {translate("sellerPayment.labels.saleDate")}:{" "}
                  {new Date(transaction.createdAt).toLocaleDateString(
                    language === "ar" ? "ar-AE" : "en-AE",
                    {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    },
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Desktop Table View */}
        <div className="hidden lg:block overflow-x-auto bg-white rounded-lg shadow-sm">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th
                  className={`px-6 py-3 ${
                    isRTL ? "text-right" : "text-left"
                  } text-xs font-medium text-gray-500 uppercase tracking-wider`}
                >
                  {translate("sellerPayment.labels.vehicle")}
                </th>
                <th
                  className={`px-6 py-3 ${
                    isRTL ? "text-right" : "text-left"
                  } text-xs font-medium text-gray-500 uppercase tracking-wider`}
                >
                  {translate("sellerPayment.labels.soldPrice")}
                </th>
                <th
                  className={`px-6 py-3 ${
                    isRTL ? "text-right" : "text-left"
                  } text-xs font-medium text-gray-500 uppercase tracking-wider`}
                >
                  {translate("sellerPayment.labels.commission")}
                </th>
                <th
                  className={`px-6 py-3 ${
                    isRTL ? "text-right" : "text-left"
                  } text-xs font-medium text-gray-500 uppercase tracking-wider`}
                >
                  {translate("sellerPayment.labels.vat5")}
                </th>
                <th
                  className={`px-6 py-3 ${
                    isRTL ? "text-right" : "text-left"
                  } text-xs font-medium text-gray-500 uppercase tracking-wider`}
                >
                  {translate("sellerPayment.labels.listingFee")}
                </th>

                <th
                  className={`px-6 py-3 ${
                    isRTL ? "text-right" : "text-left"
                  } text-xs font-medium text-gray-500 uppercase tracking-wider`}
                >
                  {translate("sellerPayment.labels.payableToKhatalJazeera")}
                </th>

                <th
                  className={`px-6 py-3 ${
                    isRTL ? "text-right" : "text-left"
                  } text-xs font-medium text-gray-500 uppercase tracking-wider`}
                >
                  {translate("sellerPayment.labels.withdrawableAmount")}
                </th>
                <th
                  className={`px-6 py-3 ${
                    isRTL ? "text-right" : "text-left"
                  } text-xs font-medium text-gray-500 uppercase tracking-wider`}
                >
                  {translate("sellerPayment.labels.saleDate")}
                </th>
                <th
                  className={`px-6 py-3 ${
                    isRTL ? "text-right" : "text-left"
                  } text-xs font-medium text-gray-500 uppercase tracking-wider`}
                >
                  {translate("sellerPayment.labels.action")}
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {paymentData.map((transaction) => (
                <tr key={transaction.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4">
                    <div>
                      <div className="text-sm font-medium text-gray-900">
                        {transaction.vehicle?.name || "-"}
                      </div>
                      <div className="text-sm text-gray-500">
                        {transaction.vehicle?.lotNumber || "-"}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900">
                    {formatPrice(
                      transaction.soldPrice,
                      "font-semibold text-green-600",
                      "12",
                      "#16a34a",
                    )}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900">
                    {formatPrice(
                      transaction.commission,
                      "font-semibold text-blue-600",
                      "12",
                      "#2563eb",
                    )}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900">
                    {formatPrice(
                      transaction.vatAmount,
                      "font-semibold text-orange-600",
                      "12",
                      "#ea580c",
                    )}
                  </td>
                  {/* //wednesday fix  showing listing fee and minus  */}
                  <td className="px-6 py-4 text-sm text-gray-900">
                    {formatPrice(
                      transaction.listingFee || 0,
                      "font-semibold text-purple-600",
                      "12",
                      "#7c3aed",
                    )}
                  </td>

                  <td className="px-6 py-4 text-sm text-gray-900">
                    {formatPrice(
                      (Number(transaction.totalCommission) || 0) +
                        (Number(transaction.listingFee) || 0),
                      "font-semibold text-red-600",
                      "12",
                      "#dc2626",
                    )}
                  </td>

                  <td className="px-6 py-4 text-sm text-gray-900">
                    {formatPrice(
                      (Number(transaction.soldPrice) || 0) -
                        (Number(transaction.totalCommission) || 0) -
                        (Number(transaction.listingFee) || 0),
                      "font-semibold text-gray-900",
                      "12",
                      "#111827",
                    )}
                  </td>
                  {/* //==================e========= */}

                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {new Date(transaction.createdAt).toLocaleDateString(
                      language === "ar" ? "ar-AE" : "en-AE",
                      {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      },
                    )}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900">
                    {/* =====================friday fix release button */}
                    {/* <button
                      disabled={
                        transaction.paymentStatus !== "Paid" ||
                        transaction.withdrawalRequestCount > 0 ||
                        transaction.buyerInvoice?.paidToSeller ||
                        releaseLoading === transaction.id
                      }
                      type="button"
                      // onClick={() => handleReleaseRequest(transaction)}
                      onClick={() => {
  setSelectedTransaction(transaction);
  setShowReleaseConfirm(true);
}}
                      className={`px-4 py-2 rounded-md text-sm whitespace-nowrap transition-colors
    ${
      transaction.paymentStatus === "Paid" &&
      !transaction.withdrawalRequestCount &&
      !transaction.buyerInvoice?.paidToSeller
        ? "bg-green-600 text-white hover:bg-green-700"
        : "bg-gray-300 text-gray-500 cursor-not-allowed"
    }`}
                    >
                      {releaseLoading === transaction.id
                        ? translate("sellerPayment.buttons.submitting") ||
                          "Submitting..."
                        : transaction.withdrawalRequestCount > 0 ||
                            transaction.buyerInvoice?.paidToSeller
                          ? translate("sellerPayment.buttons.requested") ||
                            "Release Requested"
                          : translate("sellerPayment.buttons.release")}
                    </button> */}
                    <button
  disabled={
    transaction.paymentStatus !== "Paid" ||
    transaction.withdrawalRequestCount > 0 ||
    transaction.buyerInvoice?.paidToSeller ||
    releaseLoading === transaction.id
  }
  type="button"
  onClick={() => {
    setSelectedTransaction(transaction);
    setShowReleaseConfirm(true);
  }}
className={`px-4 py-2 rounded-md text-sm whitespace-nowrap transition-colors
  ${
    transaction.buyerInvoice?.paidToSeller && transaction.markPaidBy
      ? "bg-blue-100 text-blue-700 cursor-not-allowed" // ✅ Received
    : (transaction.buyerInvoice?.paidToSeller && !transaction.markPaidBy) ||
      transaction.withdrawalRequestCount > 0
      ? "bg-yellow-100 text-yellow-700 cursor-not-allowed" // ✅ Requested (NEW COLOR)
    : transaction.paymentStatus === "Paid"
      ? "bg-green-600 text-white hover:bg-green-700" // ✅ Release
    : "bg-gray-300 text-gray-500 cursor-not-allowed"
  }`}
>
{releaseLoading === transaction.id
  ? translate("sellerPayment.buttons.submitting") || "Submitting..."
  : transaction.buyerInvoice?.paidToSeller &&
    !transaction.markPaidBy
  ? translate("sellerPayment.buttons.requested") || "Release Requested"
  : transaction.buyerInvoice?.paidToSeller
  ? "Received"
  : transaction.withdrawalRequestCount > 0
  ? translate("sellerPayment.buttons.requested") || "Release Requested"
  : translate("sellerPayment.buttons.release") || "Release"}
</button>
                    {/* //==================fridy fix ende========= */}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

{/* //==================friday fix release button for seller withdrawal invoice  */} 
{showReleaseConfirm && (
  <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
    <div className="bg-white p-6 rounded-lg shadow-lg w-96">
      <h2 className="text-lg font-semibold mb-4">
        {translate("sellerPayment.messages.releaseTitle") || "Confirm Release"}
      </h2>

      <p className="text-sm text-gray-600 mb-6">
        {translate("sellerPayment.messages.releaseMessage") ||
          "Are you sure you want to release this payment to withdrawal?"}
      </p>

      <div className="flex justify-end gap-3">
        <button
          onClick={() => {
            setShowReleaseConfirm(false);
            setSelectedTransaction(null);
          }}
          className="px-4 py-2 bg-gray-300 rounded-md"
        >
          {translate("sellerPayment.buttons.cancel") || "Cancel"}
        </button>

        <button
          onClick={handleConfirmRelease}
          className="px-4 py-2 bg-primary text-white rounded-md"
        >
          {releaseLoading
            ? translate("sellerPayment.buttons.submitting") || "Submitting..."
            : translate("sellerPayment.buttons.confirm") || "Confirm"}
        </button>
      </div>
    </div>
  </div>
)}

{/*========================= fridy fix end ========================== */}
        {/* Empty State */}
        {paymentData.length === 0 && !isLoading && (
          <div className="text-center py-12">
            <div className="text-gray-500">
              <svg
                className="mx-auto h-12 w-12 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                />
              </svg>
              <h3 className="mt-2 text-sm font-medium text-gray-900">
                {translate("sellerPayment.messages.noPaymentsFound")}
              </h3>
              <p className="mt-1 text-sm text-gray-500">
                {translate("sellerPayment.messages.noPaymentsAvailable")}
              </p>
            </div>
          </div>
        )}

        {/* Pagination */}
        {pagination.totalPages > 1 && (
          <div className="px-3 lg:px-6 py-4 border-t border-gray-200">
            <Pagination
              totalPages={pagination.totalPages}
              currentPage={pagination.currentPage}
              setCurrentPage={(page) => {
                // You can implement page change logic here
                setPagination({
                  ...pagination,
                  currentPage: page,
                });
                console.log("Page changed to:", page);
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfilePayment;
